var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-blue-900"},[_c('Hero'),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('Footer',{attrs:{"expanded":true}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }